<template>
    <div class="inner-play-space">
        <div class="container">
            <div class="section-grid-inline">
                <div class="section-grid-info inner-play-space-info">
                    <div class="title title-black title-small-width">
                        <h3 v-html="innerContentArr.section_play_space.title"></h3>
                    </div>
                    <div class="section-grid-images-desc section-grid-images-desc-black inner-play-space-images-desc" v-html="innerContentArr.section_play_space.desc_images" v-if="!isMobileG"></div>
                    <div class="desc-html desc-html-black" v-html="innerContentArr.section_play_space.desc"></div>
                </div>
                <div class="section-images-grid images-grid-opposite-left">
                    <div class="images-items">
                        <div class="item" v-for="(item, index) in innerContentArr.section_play_space.images" :key="index">
                            <img :src="item.img" alt="">
                        </div>
                    </div>
                </div>
                <!-- MOBILE -->
                <div class="section-grid-images-desc section-grid-images-desc-black inner-play-space-images-desc" v-html="innerContentArr.section_play_space.desc_images" v-if="isMobileG"></div>
            </div>
        </div>
    </div>
</template>

<script>
    // import svgIcon from '@/components/partials/SvgIcon.vue';
    // import promoForm from '@/components/forms/form.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'inner-play-space',
        data () {
            return {
            }
        },
        computed: mapGetters({
            innerContentArr: 'loadInnerContent',
            isMobileG: 'loadisMobileGlobal',
        }),
        components: {
            // svgIcon,
            // promoForm,
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/inner-content/inner-play-space.scss';
    @import '@/styles/components/inner-content/respond/inner-play-space-respond.scss';
</style>